/**
 * Users section filter field definitions.
 * Used by FilterBuilder to render the correct input for each field.
 */
import {
  COMMON_FILTER_OPERATORS,
  BOOLEAN_OPTIONS,
  PLATFORM_OPTIONS_IOS_ANDROID,
  type FilterFieldMeta,
} from '@/lib/filters';

export const USERS_FILTER_FIELDS = [
  { value: 'platform', label: 'platform' },
  { value: 'is_premium', label: 'is_premium' },
  { value: 'traffic_source', label: 'traffic_source' },
  { value: 'campaign_name', label: 'campaign_name' },
  { value: 'ad_group_name', label: 'ad_group_name' },
  { value: 'retention_days', label: 'retention_days' },
  { value: 'country', label: 'country' },
  { value: 'city', label: 'city' },
  { value: 'app_version', label: 'app_version' },
  { value: 'device_brand', label: 'device_brand' },
  { value: 'device_os_version', label: 'device_os_version' },
  { value: 'device_language', label: 'device_language' },
  { value: 'app_open_count', label: 'app_open_count' },
  { value: 'is_web_to_app_user', label: 'is_web_to_app_user' },
] as const;

export const USERS_FILTER_OPERATORS = COMMON_FILTER_OPERATORS;

export const USERS_FILTER_FIELD_META: FilterFieldMeta = {
  platform:           { type: 'dropdown', options: [...PLATFORM_OPTIONS_IOS_ANDROID] },
  is_premium:         { type: 'dropdown', options: [...BOOLEAN_OPTIONS] },
  is_web_to_app_user: { type: 'dropdown', options: [...BOOLEAN_OPTIONS] },
  traffic_source:     { type: 'text', placeholder: 'e.g., organic' },
  campaign_name:      { type: 'text', placeholder: 'e.g., PL Tier 1' },
  ad_group_name:      { type: 'text', placeholder: 'e.g., Text Only Group' },
  retention_days:     { type: 'text', placeholder: 'e.g., 1' },
  country:            { type: 'text', placeholder: 'e.g., India' },
  city:               { type: 'text', placeholder: 'e.g., Mumbai' },
  app_version:        { type: 'text', placeholder: 'e.g., 2.9.3' },
  device_brand:       { type: 'text', placeholder: 'e.g., Samsung' },
  device_os_version:  { type: 'text', placeholder: 'e.g., Android 14' },
  device_language:    { type: 'text', placeholder: 'e.g., en-us' },
  app_open_count:     { type: 'text', placeholder: 'e.g., 5' },
};
